import * as React from "react";
import { observer } from "mobx-react";
import { Box, Grid, Link, Collapse, makeStyles, ThemeProvider } from "@material-ui/core";
import * as styles from "./styles.scss";
import { themeVariables } from "..";
import Tag from "../../students/components/Tag";
import ITag from "../../../../typings/ITag";
import { Theme as theme } from "../../MUI";

interface IStyleProps {
  collapsed: boolean;
  fullWidth: boolean;
}

const useStyles = makeStyles((theme) => ({
  collapsableBox: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: (props: IStyleProps) => props.collapsed ? 'nowrap' : 'wrap',
    width: 'calc(100% + 4px)',
    alignItems: 'center',
  },
  container: {
    maxWidth: (props: IStyleProps) => props.fullWidth ? '100%' : 250,
    overflow: 'hidden',
    margin: '0 -2px',
  },
  collapseRoot: {
    width: 'calc(100% + 4px)',
  },
  expander: {
    padding: '0 4px',
    height: 18,
  },
}))
interface IProps {
  tags: ITag[];
  tagsMoreToCollaps?: number;
  fullWidth?: boolean;
}

export const MUITagsCard = observer((props: IProps) => {
  const [collapsed, setCollapsed] = React.useState(true);
  const { tags = [], tagsMoreToCollaps = 2, fullWidth = false } = props;

  const classes = useStyles({ collapsed: collapsed, fullWidth });

  return (
    <Grid container direction="row">
      <Grid item container direction="row" xs className={classes.container} onClick={
              tags?.length > tagsMoreToCollaps ? () => setCollapsed(!collapsed) : null
            }>
        {
          tags.length > 0 &&
            <Collapse 
              in={!collapsed} 
              classes={{
                wrapperInner: classes.collapsableBox,
              }}
              className={classes.collapseRoot}
              collapsedSize="22px"
            >
              {
                collapsed ? tags.slice(0,tagsMoreToCollaps).map((tag) => (
                    <Box key={tag.id} margin="2px">
                      <Tag fullWidth={tag.id === -1} color={tag.color}>{tag.tag}</Tag>
                    </Box>
                  )
                ) : tags.map((tag) => (
                  <Box key={tag.id} margin="2px">
                    <Tag fullWidth={tag.id === -1} color={tag.color}>{tag.tag}</Tag>
                  </Box>
                ))
                }
             {tags?.length > tagsMoreToCollaps && 
              <Box
                bgcolor={themeVariables.palette.grey[200]}
                borderRadius={themeVariables.shape.borderRadius}
                className={classes.expander}
                margin="2px"
              >
                <Link
                  className={styles.collapseLink}
                  underline="none"
                  onClick={() => {
                    setCollapsed(!collapsed);
                  }}
                >
                  ...
                </Link>
              </Box>
             }
              
            </Collapse>
        }
      </Grid>
    </Grid>
  )
});

const renderTagsCard = (data: any) => {
  return (
    <ThemeProvider theme={theme}>
      <MUITagsCard tags={data.tags} tagsMoreToCollaps={data.tagsMoreToCollaps} fullWidth={data.fullWidth} />
    </ThemeProvider>
  );
};

export default renderTagsCard;
